/* Global redirect to cart after any successful add-to-cart event.
 * Temporary workaround while theme cart setting "Page" is ineffective.
 */
(function () {
  function redirectToCart() {
    // Avoid loops if we are already on the cart page
    if (/^\/cart(\/|$)/.test(window.location.pathname)) return;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.assign(root + 'cart');
    } catch (e) {
      window.location.assign('/cart');
    }
  }

  // Theme-level events fired after AJAX add
  document.addEventListener('theme:cart:popdown', redirectToCart);
  document.addEventListener('theme:cart:reload', redirectToCart);

  // Fallback: if cart object changes and we're not on /cart, redirect
  document.addEventListener('theme:cart:change', function () {
    if (!/^\/cart(\/|$)/.test(window.location.pathname)) {
      redirectToCart();
    }
  });

  // Safety: intercept direct fetch responses to /cart/add.js if needed
  // (Keeps behavior consistent even if theme events don’t fire.)
  try {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      return originalFetch.apply(this, args).then(function (resp) {
        try {
          var url = (resp && resp.url) || '';
          if (url.indexOf('/cart/add') !== -1 && !/^\/cart(\/|$)/.test(window.location.pathname)) {
            // Defer slightly to avoid racing any theme handlers
            setTimeout(redirectToCart, 10);
          }
        } catch (e) {}
        return resp;
      });
    };
  } catch (e) {
    // If fetch wrapping fails, events above should still handle the redirect
  }

  // Also intercept XMLHttpRequest-based cart adds
  try {
    var OriginalXHR = window.XMLHttpRequest;
    function WrappedXHR() {
      var xhr = new OriginalXHR();
      var _url = '';
      var _open = xhr.open;
      xhr.open = function (method, url) {
        _url = url || '';
        return _open.apply(xhr, arguments);
      };
      xhr.addEventListener('load', function () {
        try {
          if (_url && _url.indexOf('/cart/add') !== -1 && !/^\/cart(\/|$)/.test(window.location.pathname)) {
            setTimeout(redirectToCart, 10);
          }
        } catch (e) {}
      });
      return xhr;
    }
    window.XMLHttpRequest = WrappedXHR;
  } catch (e) {
    // Ignore if XHR wrapping not permitted
  }

  // Fallback: Intercept standard product form submissions to ensure redirect
  // This only triggers for forms posting to /cart/add and prevents full page reloads.
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!(form && form.tagName === 'FORM')) return;
    var action = (form.getAttribute('action') || '');
    if (!/\/cart\/add(\.js)?/.test(action)) return;

    // Prevent native navigation and post via fetch, then redirect
    try {
      ev.preventDefault();
      var fd = new FormData(form);
      var method = (form.getAttribute('method') || 'POST').toUpperCase();
      // Prefer original action to preserve all properties; we don't need JSON back.
      fetch(action, { method: method, body: fd, credentials: 'same-origin' })
        .then(function () { setTimeout(redirectToCart, 10); })
        .catch(function () { setTimeout(redirectToCart, 10); });
    } catch (e) {
      // If anything goes wrong, fall back to hard redirect; server likely added the item.
      setTimeout(redirectToCart, 10);
    }
  }, true);
})();
